export const notes = state => state.experimentReducer.notes;
export const dataStepTwo = state => state.experimentReducer.dataStepTwo;
export const appended_result = state => state.experimentReducer.appended_result;
export const deviceOnline = state => state.experimentReducer.deviceOnline;
export const pumpsOnline = state => state.experimentReducer.pumpsOnline;
export const reactorsOnline = state => state.experimentReducer.reactorsOnline;
export const connectivity = state => state.experimentReducer.connectivity;
